module.exports = __webpack_public_path__ + "static/img/gzh.5f8e1ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gzh.jpg
// module id = Tla2
// module chunks = 1